import { useApi } from "utils"
import { ApproveType } from "../../types"
import { useEffect, useState } from "react"
import { SuccessFetch } from "types"

export function useGetAllApproval({ approval_status }: { approval_status: number }) {
  const api = useApi()
  const [data, setData] = useState<ApproveType[]>([])
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {}
  if (approval_status) params.approve_status = approval_status

  const fetchingApi = () => api.get("/opening-stock/byapproval_status_all", { params })

  const fetchData = () => {
    setLoading(true)

    fetchingApi()
    .then((res: SuccessFetch<{ payload: ApproveType[]}>) => setData(res.data.payload))
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(true)
    }
    // eslint-disable-next-line
  }, [approval_status])

  return { data, isLoading, refetch }
}
